<div data-cy="attachments-list">
  <span class="label" data-cy="attachments-list-title">Attachments</span>
  <span data-cy="attachments-list-content">
    @if (attachments?.length > 0) {
      <app-file-list [files]="attachmentsList"
      (downloadClick)="downloadFile($event)"></app-file-list>
    } @else {
      @if (requiredAttachments) {
        <app-warning-inline [warningType]="WarningsEnum.WARNING_SEND"
          data-cy="attachment-list-warning-mandatory"
        warningInlineLabel="Required for send"></app-warning-inline>
      } @else {
        <span data-cy="attachments-list-not-required">-</span>
      }
    }
  </span>
</div>
